

import React from 'react';
import { compose, lifecycle } from 'react-recompose';
import styled from 'styled-components';

import ui from '~/state/ducks/ui/actions';
import withReduxConnect from '~/views/enhancers/withReduxConnect';


import logoSVG from '~/images/starkiller.svg';


const Container = styled.div`
    display: flex;
    align-items: center;
`;

const Star = styled.div`
    font-size: 5rem;
    font-weight: bold;
    line-height: 5rem;
    color: ${p => p.theme.color.black};
`;

const Base = styled.div`
    font-size: 2rem;
    line-height: 2rem;
    color: ${p => p.theme.color.black};
`;

const Logo = styled.img.attrs({
    src: logoSVG,
    alt: 'StarkillerBase logo',
})`
    height: 200px;
    width: auto;
    margin-right: 2rem;
`;

const Home = () => (
    <Container>
        <Logo />
        <div>
            <Star>STARKILLER</Star>
            <Base>BASE</Base>
        </div>
    </Container>
);

export default compose(
    withReduxConnect({
        mapDispatchToProps: {
            handleShowSideBar: ui.sidebar.show,
        },
    }),
    lifecycle({
        componentDidMount() {
            this.props.handleShowSideBar();
        },
    }),
)(Home);

